import AiFillStar from '../icons/AiFillStar';
import AiOutlineStar from '../icons/AiOutlineStar';
import PropTypes from 'prop-types';
import React from 'react';
import '../styles/StarRating.css';


/** CONFIGURATION */
const MAX_STARS = 5;

/**
 * Display the rating in stars.
 * @component
 */
const StarRating = ({
    clickable = false,
    color = 'gold',
    rating = 0,
    setRating = (value) => {},
    size = '1rem',
}) => <div>
    {[...Array(MAX_STARS)].map((_, index) => <button
        className={'star-rating--button'}
        disabled={!clickable}
        key={index}
        type={'button'}
        onClick={() => setRating(index + 1)}
    >
        {rating > index
            ? <AiFillStar
                key={index}
                size={size}
                color={color} />
            : <AiOutlineStar
                color={'grey'}
                key={index}
                size={size} />
        }
    </button>)}
</div>;

/** Prop Types */
StarRating.propTypes = {
    /** Indicate whether the stars are clickable or not. */
    clickable: PropTypes.bool,
    /** The color of the stars when filled. */
    color: PropTypes.string,
    /** The rating value. */
    rating: PropTypes.number,
    /** The setter for the rating value. */
    setRating: PropTypes.func,
    /** The size of the stars. */
    size: PropTypes.string,
};

export default StarRating;
